import { useEffect } from 'react';
import { Prompt } from 'react-router-dom';

function UnsavedChanges({
  message = 'Ayrılmak istediğinizden emin misiniz? Kaydedilmemiş değişiklikleriniz var.',
  dirty
}) {
  useEffect(() => {
    // Detecting browser closing
    window.onbeforeunload = () => dirty && message;
    return () => (window.onbeforeunload = null);
  }, [dirty, message]);

  const allowNavigate = () => message;

  return <Prompt when={dirty} message={allowNavigate} />;
}

export default UnsavedChanges;
